<template>
  <ul :class="menuClass" @click.stop="noop">
    <TreeMenuItem
      v-for="item in effectiveItems"
      :key="item.id"
      v-bind="getItemDataAttrs(item)"
      :item="item"
      :parent-level="level"
      :expanded-items="expandedItems"
      :selected="item.selected && isSelectedHighlight"
      :variant="variant"
      :ctrl-click="ctrlClick"
      :is-dimmed="isDimmed"
      :get-item-data-attrs="getItemDataAttrs"
      @item-expanded="handleItemExpanded"
      @item-highlighted="handleItemHighlighted"
      @item-toggled="itemToggled"
      @item-clicked="itemClicked"
    >
      <template #accent="{ itemForSlot }">
        <slot name="accent" :item-for-slot="itemForSlot" />
      </template>
      <template #itemSlot="{ itemForSlot }">
        <slot name="itemSlot" :item-for-slot="itemForSlot" />
      </template>
    </TreeMenuItem>
  </ul>
</template>

<script>
import TreeMenuItem from './tree-menu-item'

export default {
  name: 'TreeMenu',
  components: { TreeMenuItem },
  props: {
    level: {
      type: Number,
      default: 1,
    },
    items: {
      type: Array,
      required: true,
    },
    expandedItems: {
      type: Object,
      default: () => ({}),
    },
    seemless: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
    ctrlClick: {
      type: Boolean,
      default: false,
    },
    isDimmed: {
      type: Function,
      default: () => () => false,
    },
    getItemDataAttrs: {
      type: Function,
      default: () => () => ({}),
    },
  },
  emits: ['item-clicked', 'item-expanded', 'item-highlighted', 'item-toggled'],
  computed: {
    effectiveItems() {
      return this.items.filter((item) => item)
    },
    isRoot() {
      return this.level === 1
    },
    isTopSubmenu() {
      return this.level === 2
    },
    menuClass() {
      if (this.isRoot && !this.seemless) {
        return {
          'sf-tree-menu': true,
          'tw-m-0': true,
          'tw-p-0': true,
          'tw-list-none': true,
          'tw-flex': true,
          'tw-flex-col': true,
          'tw-gap-0.5': true,
        }
      }

      return {
        'sf-tree-menu__group-content': true,
        'sf-tree-menu__group-content--top-level': this.isTopSubmenu,
        'tw-m-0': true,
        'tw-p-0': true,
        'tw-list-none': true,
        'tw-flex': true,
        'tw-flex-col': true,
        'tw-gap-0.5': true,
        'sf-tree-menu__group-content--slim':
          !this.isRoot && this.variant === 'slim',
        'tw-border-sf-slate-lighter-1': !this.isRoot && this.variant !== 'slim',
      }
    },
    isSelectedHighlight() {
      return this.variant === 'default' || this.variant === 'slim'
    },
  },
  methods: {
    noop: () => {},
    handleItemExpanded(itemId) {
      this.$emit('item-expanded', itemId)
    },
    handleItemHighlighted(itemId) {
      this.$emit('item-highlighted', itemId)
    },
    itemClicked: function (data) {
      this.$emit('item-clicked', data)
    },
    itemToggled(itemId) {
      this.$emit('item-toggled', itemId) // bubble the event
    },
  },
}
</script>
<style scoped>
/*
 * Tailwind tw-border-l-0 (specificity 0,1,0) cannot override UIkit's
 * `ul .sf-tree-menu__group-content { border-left: 1px solid }` (0,1,1).
 * The scoped [data-v-*] attribute selector raises specificity to (0,2,1).
 */
ul.sf-tree-menu__group-content--slim {
  border-left: none;
  margin-left: 0;
}
</style>
